import { Modal } from "react-bootstrap";
import "./files.scss";
import cross from "../../images/cross.svg";
import parse from "html-react-parser";

const ContractModal = ({ offer, ...props }) => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="info-modal">
        <p>
          <img src={cross} className="info-modal-img" onClick={props.onHide} alt="" />
        </p>
        <div className="info-modal-main">
          <p className="info-modal-title">Договор оферты о сотрудничестве</p>

          <p className="info-modal-text">{parse(offer.replace(/style="[^"]+"/g))}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContractModal;
